<template>
    <div>
        <div class="text-center mb-5">
            <picture>
                <source :srcset="initialBanner.bannerMobile" media="(max-width: 576px)" />
                <source :srcset="initialBanner.bannerTablet" media="(max-width: 768px)" />
                <img
                    :src="initialBanner.bannerDesktop"
                    alt="Guia de Tamanhos"
                    class="img-responsive"
                />
            </picture>
        </div>
        <div class="content">
            <h1 class="mb-3">Descubra o tamanho ideal das suas peças</h1>
            <p>
                O Guia de Tamanhos da Chico Rei é um espaço para te ajudar a descobrir qual o
                tamanho ideal das suas peças. Aqui, você encontra a
                <span><SizesGuideTableV2 :models-data="modelsData" /></span>
                de todos os produtos e consegue visualizar como as nossas roupas vestem os mais
                diversos corpos.
                <!--                 Além disso, para te ajudar ainda-->
                <!--                mais nessa missão, nosso time criativo preparou um-->
                <!--                <strong>tutorial para medir camisetas</strong>, com dicas valiosas que não vão te-->
                <!--                deixar errar na hora de comprar online.-->
            </p>

            <p>
                A Chico Rei oferece vários produtos que abraçam diversos corpitchos bacanas. Escolha
                o produto que deseja conferir:
            </p>

            <div class="topic-guides d-flex flex-justify-center">
                <div
                    v-for="model in modelsData"
                    class="topic-content"
                    v-if="model.size_guide_cover_desktop && model.size_guide_cover_mobile"
                >
                    <router-link :to="getRouteLink(model)">
                        <picture>
                            <source
                                :srcset="getCoverImageDesktop(model)"
                                media="(max-width: 576px)"
                            />
                            <img
                                :src="getCoverImageMobile(model)"
                                :alt="getModelName(model)"
                                class="img-responsive"
                            />
                        </picture>
                        <p>{{ getModelName(model) }}</p>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SizesGuideTableV2 from '../sizes-guide/SizesGuideTableV2.vue';

    export default {
        name: 'SizeGuideList',

        components: { SizesGuideTableV2 },

        props: {
            modelsData: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                initialBanner: {
                    bannerDesktop:
                        this.$scope.CDN_IMAGES +
                        `/images/site/2023/guia-de-tamanhos/guiadetamanhos-desktop-max.png?auto=compress,format&q=65`,
                    bannerMobile:
                        this.$scope.CDN_IMAGES +
                        `/images/site/2023/guia-de-tamanhos/guiadetamanhos-mobile.png?auto=compress,format&q=65`,
                    bannerTablet:
                        this.$scope.CDN_IMAGES +
                        `/images/site/2023/guia-de-tamanhos/guiadetamanhos-tablet.png?auto=compress,format&q=65`,
                },
                showTable: false,
            };
        },

        methods: {
            getRouteLink(data) {
                return (
                    data.product_type.nome +
                    '-' +
                    (data.filter_name || 'regular') +
                    '-' +
                    data.id
                )
                    .toLowerCase()
                    .replaceAll(' ', '-');
            },

            getCoverImageMobile(data) {
                return this.$scope.CDN_IMAGES + '/' + data.size_guide_cover_mobile;
            },

            getCoverImageDesktop(data) {
                return this.$scope.CDN_IMAGES + '/' + data.size_guide_cover_desktop;
            },

            getModelName(data) {
                return data.product_type.nome + ' ' + (data.filter_name || '');
            },
        },
    };
</script>
